// Must match SELF_EDIT_WINDOW_DAYS in api/lib/post-reference.ts.
export const POST_SELF_EDIT_WINDOW_DAYS = 7;
export const POST_SELF_EDIT_WINDOW_MS = POST_SELF_EDIT_WINDOW_DAYS * 24 * 60 * 60 * 1000;

const formatWindowLabel = (days: number) =>
  days % 7 === 0
    ? `${days / 7} ${days / 7 === 1 ? 'week' : 'weeks'}`
    : `${days} ${days === 1 ? 'day' : 'days'}`;

export const POST_SELF_EDIT_WINDOW_LABEL = formatWindowLabel(POST_SELF_EDIT_WINDOW_DAYS);
